<template>
  <div class="global-wrapper">
    <div class="level is-marginless">
      <v-search @select="onSearch($event)" />
      <v-search-country @select="onSearchCountry($event)" />
      <div class="field mb-0">
        <div class="heading">
          Filter by birth year
        </div>
        <div class="field has-addons">
          <p
            v-for="date in dates"
            :key="date.label"
            class="control"
            @click="updateDate(date.value)"
          >
            <a
              class="button is-small"
              :class="{'is-dark': (filters.dateRange == null && date.value == null) || (filters.dateRange != null && date.value != null && date.value[0] == filters.dateRange[0] && date.value[1] == filters.dateRange[1])}"
            >
              <span>{{ date.label }}</span>
            </a>
          </p>
        </div>
      </div>
    </div>
    <svg
      id="axis-svg"
      class="plot"
    ></svg>
    <canvas
      id="plot-canvas"
      class="plot"
    />
    <portal to="tooltip">
      <v-tooltip
        :artist="artist" 
      />
    </portal>
  </div>
</template>

<script>
import Global from "./global";
import Tooltip from "./Tooltip.vue";
import { toArtist } from "@/services/navigator";
import SearchArtistVue from "./SearchArtist.vue";
import SearchCountryVue from "./SearchCountry.vue";

export default {
	components: {
		"v-tooltip": Tooltip,
		"v-search": SearchArtistVue,
		"v-search-country": SearchCountryVue,
	},
	data () {
		return {
			artist: null,
			filters: {
				dateRange: null
			}
		};
	},
	computed: {
		dates () {
			let dates = [
				{label: "All", value: null}
			];
			let step = 20;

			for (let i = 1900; i < 2020; i += step) {
				dates.push({
					label: `${i}-${i+step}`,
					value: [i, i+step]
				});
			}

			return dates;
		},
	},
	mounted () {
		this.global = new Global(
			this.$store.state.artists, 
			this.$store.state.songs, 
			{ onHover: this.onHover, onClick: this.onClick }
		);
	},
	methods: {
		onHover (id) {
			if (id == null) {
				this.artist = null;
			} else {
				this.artist = this.$store.state.artists[id];
			}
		},
		onClick (id) {
			toArtist(id);
		},
		onSearch (id) {
			this.global.selectById(id);
		},
		updateDate (dateRange) {
			this.filters.dateRange = dateRange;
			this.global.filterByDate(dateRange);
		},
		onSearchCountry (country) {
			this.global.filterByCountry(country);
		}
	}
};
</script>

<style lang="scss">
.global-wrapper {
  #plot-canvas {
      position: absolute;
      z-index: 2;
      left: 0;
  }

  #axis-svg {
      z-index: 1;
  }

  .domain {
    display: none;
  }

  .axis path,
  .axis line {
      fill: none;
      stroke: #000;
      shape-rendering: crispEdges;
  }

  .tick line {
      opacity: 0.1;
  }

  .tick text {
    display: none;
  }
}
</style>